import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = { class: "value-container" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "value"
}
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "value" }

import { computed, ref } from 'vue';
	import axios from 'axios';
	import functions from '@/use/functions';
	import PermissionsWrapper from '@/components/wrappers/PermissionsWrapper.vue';
	import { Permissions, PermissionLevels } from '@/models/permissions';
	import { LoanDetails, LocMetadata } from '@/models/loans';
	import LocMetadataForm from './LocMetadataForm.vue';
	import { useUpdateLocMetadataFormFields } from '@/composables/loan/useUpdateLocMetadataForm';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'ServicerDetailsCard',
  props: {
    loanDetails: {},
    onUpdateLoan: { type: Function }
  },
  setup(__props: any) {

	const props = __props;

	const isSubmitting = ref<boolean>(false);
	const locMetadataFormVisible = ref<boolean>(false);

	const locMetadata = computed<LocMetadata | null>(() => props.loanDetails.locMetadata);
	const servicerName = computed(() => props.loanDetails.servicerPartner?.name || 'N/A');
	const adminLoginUrl = computed(() => props.loanDetails.servicerPartner?.adminLoginUrl);

	const { formFields, validationSchema } = useUpdateLocMetadataFormFields({
		locMetadata
	});

	const showLocMetadataModal = () => (locMetadataFormVisible.value = true);
	const closeLocMetadataModal = () => (locMetadataFormVisible.value = false);

	async function updateLocMetadataAsync(formData: Record<string, any>) {
		isSubmitting.value = true;

		const loanId = props.loanDetails.loan.id;
		const referenceId = props.loanDetails.loan.referenceId;

		try {
			// sanitize override amount
			formData.drawOverrideAmount = String(formData.drawOverrideAmount).replace(/[$,]/g, '');

			const request = {
				loanId,
				...formData
			};

			await axios.patch(`/api/loanservice/loans/${loanId}/locmetadata`, request);

			await props.onUpdateLoan();

			closeLocMetadataModal();

			functions.openModal({
				title: 'Success!',
				description: `Successfully updated the loc override for loan ${referenceId}!`
			});
		} catch (error) {
			functions.openModal({
				title: 'Oops!',
				description: `There was an issue updating the loc override for loan ${referenceId}. Please try again later.`
			});
		} finally {
			isSubmitting.value = false;
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("h3", null, "Servicer Details")
      ], -1)),
      (__props.loanDetails.loan.productType === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "Draw Status", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "dots" }, null, -1)),
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(__props.loanDetails.locStatusHumanized), 1),
              _createVNode(PermissionsWrapper, {
                permissionIds: [_unref(Permissions).LoanDetails],
                permissionLevel: _unref(PermissionLevels).Update
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", { onClick: showLocMetadataModal }, "Override")
                ]),
                _: 1
              }, 8, ["permissionIds", "permissionLevel"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "Repayment Type", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "dots" }, null, -1)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.loanDetails.repaymentTypeHumanized), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "Repayment Term", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "dots" }, null, -1)),
        _createElementVNode("span", _hoisted_8, _toDisplayString(__props.loanDetails.repaymentTermFormatted), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "Loan Stage", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "dots" }, null, -1)),
        _createElementVNode("span", _hoisted_10, _toDisplayString(__props.loanDetails.loanStageHumanized), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "Servicer Name", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dots" }, null, -1)),
        (adminLoginUrl.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: adminLoginUrl.value,
              class: "value",
              target: "_blank"
            }, _toDisplayString(servicerName.value), 9, _hoisted_12))
          : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(servicerName.value), 1))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "Id at Servicer", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "dots" }, null, -1)),
        _createElementVNode("span", _hoisted_15, _toDisplayString(__props.loanDetails.servicerLoanData?.servicerLoanId || 'N/A'), 1)
      ])
    ]),
    (locMetadataFormVisible.value)
      ? (_openBlock(), _createBlock(LocMetadataForm, {
          key: 0,
          isSubmitting: isSubmitting.value,
          fields: _unref(formFields),
          validationSchema: _unref(validationSchema),
          onSubmit: updateLocMetadataAsync,
          onClose: closeLocMetadataModal
        }, null, 8, ["isSubmitting", "fields", "validationSchema"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})